module.exports = __webpack_public_path__ + "static/media/pluginSuccess.475d4732.png";